var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.33.54H6.183c-1.868 0-3.945.785-3.945 3.492.009.943 0 1.847 0 2.863H.078v3.438h2.227v9.898h4.093v-9.963h2.701l.245-3.382H6.327s.007-1.505 0-1.942c0-1.07 1.113-1.009 1.18-1.009.53 0 1.56.002 1.825 0V.54z"
  })));
};
export default SvgIconFacebook;